import React from "react";

function PrimaryButton({ children, type = "button", ...props }) {
  return (
    <button type={type} {...props}>
      {children}
    </button>
  );
}

export default PrimaryButton;
